export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/IN-57472cb5aaa2280cc565c8d79790cd22.png";